import * as React from 'react';
import { DisplayCellWrapper } from './DisplayCellWrapper';
import { IDisplayCellMeta, SerialNumberCell } from './DisplayCells';

export const displayAggregateCells: IDisplayCellMeta[] = [
    {
        id: 'Row #',
        field: null,
        render: ({ rowNumber, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Row #" align-middle>
                {rowNumber}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Serial Number',
        field: 'SerialNumber',
        render: props => <SerialNumberCell {...props} />,
    },
    {
        id: 'Unit Serial Number',
        field: 'Display.UnitSerialNumber',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Unit Serial Number">
                {display.unitSerialNumber ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Display ID',
        field: 'Display.DisplayConnectionData?.CustomerDisplayID',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Display ID">
                {display.displayConnectionData?.customerDisplayID ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Site ID',
        field: 'UnitLocation?.CustomerSiteID',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Site ID">
                {display.unitLocation?.customerSiteID ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Address',
        field: null,
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Address">
                {display.fullAddress ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'City',
        field: 'UnitLocation?.City',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="City">
                {display.unitLocation?.city ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'State Or Province',
        field: 'UnitLocation?.StateOrProvince',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="State Or Province">
                {display.unitLocation?.stateOrProvince ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Country',
        field: 'UnitLocation?.Country',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Country">
                {display.unitLocation?.country ?? '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Runtime Percent',
        field: 'Display.Aggregates.RuntimePercent',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Runtime Percent">
                {display.aggregates?.runtimePercent ? `${display.aggregates?.runtimePercent.toFixed(2)}%` : '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Play Count',
        field: 'Display.Aggregates.PopVuPlayCount',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Play Count">
                {display.aggregates?.popVuPlayCount ? `${display.aggregates?.popVuPlayCount}` : '-'}
            </DisplayCellWrapper>
        ),
    },
    {
        id: 'Play Duration Average',
        field: 'Display.Aggregates.PopVuDurationAverage',
        render: ({ display, vm }) => (
            <DisplayCellWrapper vm={vm} cellId="Play Duration Average">
                {display.aggregates?.popVuDurationAverage
                    ? `${display.aggregates?.popVuDurationAverage.toFixed(2)}s`
                    : '-'}
            </DisplayCellWrapper>
        ),
    },
];
